import React from "react";
import CartItem from "./CartItem";
import ShareInquiryForm from "../Forms/ShareInquiryForm";

import { FaTrash, FaArrowAltCircleRight, FaArrowAltCircleLeft } from "react-icons/fa";
import { FiShare } from "react-icons/fi";
import { cejnToast, deleteCart } from "../../api/api";

// redux
import { useDispatch, useSelector } from "react-redux";
import { setCart } from "../../redux/cartSlice";

export default function Cart(props) {
  const [showShare, setShowShare] = React.useState(false);

  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cartData.cart);
  const checkoutUrl = useSelector((state) => state.cartData.checkoutUrl);

  const handleDelete = async () => {
    let data = await deleteCart();
    if (!data?.status.success) {
      cejnToast(data.status.message ?? i18n.getString("cejnToast.errors.deleteCart"), "ERROR");
      return;
    }

    dispatch(setCart(data.items));
    cejnToast(data.status.message);
  };

  const handleSuccessShare = (message) => {
    setShowShare(false);

    // remove if not used
    //props.showSuccessShare(message);
  };

  if (!cart?.length) {
    return (
      <div className="c-cart__cart-empty">
        <span>{i18n.getString("inquiryList.listEmpty")}</span>
      </div>
    );
  }

  if (showShare) {
    return (
      <div className="c-cart__share-form">
        <div role="button" className="c-cart__back-arrow" onClick={() => setShowShare(false)}>
          <FaArrowAltCircleLeft />
          <span>{i18n.getString("goBack")}</span>
        </div>

        <ShareInquiryForm hideForm={(message) => handleSuccessShare(message)} />
      </div>
    );
  }

  return (
    <>
      <div className={"c-cart__table-container" + (!props.isCheckout ? " c-cart__overflow-table" : "")}>
        <table className="c-cart__table">
          <tbody>
            {cart?.map((row) => {
              return (
                <CartItem
                  isCheckout={props.isCheckout}
                  row={row}
                  onUpdate={(quantity) => updateItem(row.code, quantity)}
                  key={row.code}
                  onDelete={() => deleteItem(row.code)}
                />
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="c-cart__buttons-container">
        {/* Hide the share button if we're not in the minicart */}
        {!props.isCheckout && (
          <button className="c-flex-button__transparent" type="button" onClick={() => setShowShare(true)}>
            <span>{i18n.getString("share")}</span>
            <FiShare />
          </button>
        )}

        <button
          className="c-flex-button__gray"
          type="button"
          onClick={() => window.confirm(i18n.getString("inquiryList.clearConfirm")) && handleDelete()}
        >
          <span>{i18n.getString("inquiryList.clearList")}</span>
          <FaTrash />
        </button>
      </div>

      {/* Hide the request button if we're not in the minicart */}
      {!props.isCheckout && (
        <div className="c-cart__request-button">
          <a href={checkoutUrl} className="c-flex-button__green">
            {i18n.getString("inquiryList.requestButton")}
            <FaArrowAltCircleRight />
          </a>
        </div>
      )}
    </>
  );
}
